// ----------------------------------------------------------------------

import { format } from "date-fns";

// type InputValue = Date | string | number | null | undefined;

// export function fDate(date: InputValue, newFormat?: string) {
//   const fm = newFormat || 'dd MMM yyyy';

//   return date ? format(new Date(date), fm) : '';
// }

export function fDateTime(date: string, newFormat?: string) {
	const fm = newFormat ?? "dd MMM yyyy p";

	return date ? format(new Date(date), fm) : "";
}
export function getLastMonth(): Date {
	return getPastMonth(0);
}

export function getLastThreeMonths(): Date {
	return getPastMonth(2);
}

export function getLastSixMonths(): Date {
	return getPastMonth(5);
}

function getPastMonth(monthsAgo: number): Date {
	const today = new Date();

	return new Date(today.getFullYear(), today.getMonth() - monthsAgo, 1);
}
// export function fTimestamp(date: InputValue) {
//   return date ? getTime(new Date(date)) : '';
// }

// export function fToNow(date: InputValue) {
//   return date
//     ? formatDistanceToNow(new Date(date), {
//         addSuffix: true,
//       })
//     : '';
// }
export const calculateDays = (date: string) => {
	const currentDate = new Date();
	const expireDate = new Date(date);
	const differenceInMs: number = expireDate.getTime() - currentDate.getTime();

	// Define the number of milliseconds in a day
	const millisecondsInDay: number = 1000 * 60 * 60 * 24;

	// Calculate the difference in days by
	// dividing the difference in milliseconds by
	// milliseconds in a day
	const differenceInDays: number = Math.floor(differenceInMs / millisecondsInDay);

	return differenceInDays;
};
